module.exports = __webpack_public_path__ + "static/media/email-success-icon.eb280d8e.svg";